import * as React from 'react'
import { Redirect } from 'react-router-dom';
import { OperationMessage } from '../../presentational/application/OperationMessage';
import { connect } from 'react-redux';
import { ROUTES } from 'config/routes';
import * as App from 'application';

export interface IAuthenticationHandlerProps {
	location: any;
	isAuthenticated: boolean;
	authenticateUserFromUrlHash(hash);
}

const mapStateToProps = (state) => ({
	isAuthenticated: App.Authentication.isAuthenticated(state)
});

const mapDispatchToProps = (dispatch) => ({
	authenticateUserFromUrlHash: (hash) => App.Authentication.authenticate(hash, dispatch),
});

/** Processes authentication response (hash) from Auth0  */
const AuthenticationHandlerComponent: React.SFC<IAuthenticationHandlerProps> = (props) => {
	//ToDo: review => render is called multiple times due to changes on app state
	const { location, isAuthenticated } = props;
	if (/access_token|id_token|error/.test(location.hash) && isAuthenticated === false) {
		props.authenticateUserFromUrlHash(location.hash)
		return <OperationMessage message="Authenticating..." />;
	} else {
		// Calling handler without correct arguments => Redirect Away to root
		return <Redirect to={ROUTES.HOME} />;
	}
}

export const AuthenticationHandler = connect(mapStateToProps, mapDispatchToProps)(AuthenticationHandlerComponent)
//export const AuthenticationHandler = AuthenticationHandlerComponent;


// WEBPACK FOOTER //
// ./src/components/containers/handlers/AuthenticationHandler.tsx